// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9301 ? "85a27759" : chunkId) + "." + {"5912":"b8aa6ed62e4db348","9301":"1b3ed0132687664f"}[chunkId] + ".js";
};